<script lang="ts" setup>
import type { GetAddressesResponse, GetAddressesResponseItem } from '@vue-storefront/prestashop-api';

const props =defineProps<{ type: string; useSameAddressForBilling: boolean }>();
const { data: cart } = useCart();
const { query, mutationSelect, currentAddressDelivery, currentAddressInvoice } = useAddresses();
const creating = ref(false);
const editing = ref<GetAddressesResponse['psdata'][0] | null>(null);

const isAlreadySelected = (address: GetAddressesResponseItem) => {
  if (props.type == 'id_address_delivery') {
    return address.id != currentAddressDelivery?.value?.id;
  } else if (props.type == 'id_address_invoice') {
    return address.id != currentAddressInvoice?.value?.id;
  }
  return false;
};
</script>

<template>
  <div v-if="query.isLoading">
    <Skeleton class="h-16 w-full" />
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4" v-if="!creating && !editing">
    <div v-for="address in query.data" class="mb-2">
      <div
        class="group flex flex-col w-full text-left rounded-md px-6 py-4 transition-colors border shadow-xs"
        :class="{
          'border-primary-500 bg-primary-50 shadow-sm': (type == 'id_address_delivery' && address.id == currentAddressDelivery?.id) || (type == 'id_address_invoice' && address.id == currentAddressInvoice?.id),
        }"
      >
        <UserShippingAddress v-bind="address" />
        <div class="flex flex-wrap items-center gap-3 mt-4">
          <Button
            variant="secondary"
            v-if="isAlreadySelected(address)"
            size="sm"
            class="min-w-[80px]"
            @click="() => {
              if (type == 'id_address_delivery') {
                mutationSelect.mutate({ id_address_delivery: address.id, id_address_invoice: useSameAddressForBilling ? address.id : cart.id_address_invoice });
              } else if (type == 'id_address_invoice') {
                mutationSelect.mutate({ id_address_delivery: cart.id_address_delivery, id_address_invoice: address.id });
              }
            }"
          >
            {{ $t('Select address') }}
          </Button>
          <Button
            variant="secondary"
            size="sm"
            class="min-w-[80px]"
            @click="editing = address"
          >
            {{ $t('Edit') }}
          </Button>
        </div>
      </div>
    </div>
    <div class="mt-2 col-span-full">
      <Button
        @click="creating = true"
        variant="secondary"
        class="px-6 py-2"
      >
        {{ $t('Add new address') }}
      </Button>
    </div>
  </div>
  <div v-else>
    <AddressForm
      v-if="creating"
      type="shippingAddress"
      @on-address-list="
        () => {
          creating = false;
          editing = null;
        }
      "
    />
    <AddressForm
      v-if="editing"
      :saved-address="editing"
      type="shippingAddress"
      @on-address-list="
        () => {
          creating = false;
          editing = null;
        }
      "
    />
  </div>
</template>
